module.exports = __webpack_public_path__ + "img/BG-6.78cf545.png";